import OutLineMobileTwo from '@assets/icons/outline-mobile-two.svg'
import { Icon } from './Icon'

export const OutLineMobileTwoIcon = Icon(OutLineMobileTwo)
